//
//
//
//
//

export default {
  created () {
    this.$router.push('/')
  }
}
